import React, {createContext, useCallback, useEffect, useMemo, useState} from "react";
import PropTypes from "prop-types";

// Contexts
import {useSocket} from "./socket";
import {useToast} from "./toast";
import {toTitleCase} from "../utils/helpers";

const GlobalContext = createContext();

const LISTEN_NOTIFY_DELETION_SUCCESS = "notify:facility_deletion";

const GlobalProvider = ({children}) => {
  const socket = useSocket();
  const {addToast} = useToast();

  const [deletingFacilities, setDeletingFacilities] = useState([]);

  const handleNotifyFacilityDelete = useCallback(
    ({facilityId, facilityName, facilityType, result}) => {
      if (result === "success") {
        addToast(`${facilityName} ${toTitleCase(facilityType)} successfully deleted.`, result);
        setDeletingFacilities(prev => {
          const temp = prev ? {...prev} : {};
          temp[facilityId] = true;
          return temp;
        });
      } else if (result === "error") {
        addToast(`Failed to delete ${facilityName} ${toTitleCase(facilityType)}.`, result);
        setDeletingFacilities(prev => {
          const temp = prev ? {...prev} : {};
          delete temp[facilityId];
          return temp;
        });
      }
    },
    [setDeletingFacilities, addToast]
  );

  useEffect(() => {
    socket?.on(LISTEN_NOTIFY_DELETION_SUCCESS, handleNotifyFacilityDelete);

    return () => {
      socket?.off(LISTEN_NOTIFY_DELETION_SUCCESS, handleNotifyFacilityDelete);
    };
  }, [socket, handleNotifyFacilityDelete]);

  const value = useMemo(() => ({deletingFacilities, setDeletingFacilities}), [deletingFacilities]);

  return <GlobalContext.Provider value={value}>{children}</GlobalContext.Provider>;
};

GlobalProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export {GlobalContext};
export default GlobalProvider;
